import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function Nav() {
  const { isAuthenticated, isAdmin, user, logout, tier } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/');
    setMenuOpen(false);
  };

  const isActive = (path) => location.pathname === path ? 'nav-link active' : 'nav-link';

  const effectiveTier = isAdmin ? 'pro' : tier;
  const tierLabel = effectiveTier === 'pro' ? 'Pro' : effectiveTier === 'members' ? 'Members' : 'Free';
  const tierClass = effectiveTier === 'pro' ? 'pro' : effectiveTier === 'members' ? 'members' : '';
  const primaryAppPath = effectiveTier === 'members' || effectiveTier === 'pro' ? '/list' : '/dashboard';

  return (
    <nav className="nav">
      <div className="nav-inner">
        <Link to="/" className="nav-brand" aria-label="Kno U Kno home">
          <img
            src="/logo.png"
            alt="Kno U Kno"
            className="nav-brand-logo"
          />
          <span className="nav-brand-text">Kno<span>U</span>Kno</span>
        </Link>

        <div className="nav-links">
          <Link to="/" className={isActive('/')}>Home</Link>
          <Link to="/about" className={isActive('/about')}>About</Link>
          <Link to="/price" className={isActive('/price')}>Pricing</Link>

          {isAuthenticated ? (
            <>
              <Link to={primaryAppPath} className={location.pathname === '/dashboard' || location.pathname === '/list' || location.pathname === '/titles' || location.pathname === '/title' ? 'nav-link active' : 'nav-link'}>
                Dashboard
                {tierClass && (
                  <span className={`nav-tier-badge ${tierClass}`}>{tierLabel}</span>
                )}
              </Link>
              {isAdmin && (
                <Link to="/admin" className={isActive('/admin')}>Admin</Link>
              )}
              <button
                className="nav-link btn-nav"
                onClick={handleLogout}
                style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '0.45rem 1rem', borderRadius: '4px', fontWeight: 600, fontSize: '0.92rem', color: '#2c3e50' }}
              >
                Log Out
              </button>
            </>
          ) : (
            <>
              <Link to="/login" className={isActive('/login')}>Login</Link>
              <Link to="/register" className="nav-link btn-nav">Get Started</Link>
            </>
          )}
        </div>
      </div>
    </nav>
  );
}
